import React from 'react';
import '../css/bg.css';
import image from '../images/service_hero_new.png';

// Service Data
const coreTechnologies = [
  { href: "/dataAnalytics", title: "Data Analytics", icon: "📊" },
  { href: "/cloud", title: "Cloud Computing", icon: "☁️" },
  { href: "/web", title: "Web Development", icon: "🌐" }
];

const rangeOfServices = [
  {
    title: "Issue Resolution",
    icon: "🔧",
    text: "We have a proven track record of effectively identifying and resolving technical issues that can hinder the smooth operation of your IT systems. Our team possesses extensive experience in troubleshooting and debugging."
  },
  {
    title: "Implementation Assistance",
    icon: "🚀",
    text: "When it comes to implementing new systems or upgrading existing ones, our team is here to guide you every step of the way. We work closely with your organisation to develop implementation strategies."
  },
  {
    title: "Documentation Creation",
    icon: "📝",
    text: "We understand the importance of comprehensive documentation to facilitate system maintenance and knowledge transfer. Our experts specialise in creating detailed and user-friendly documentation."
  },
  {
    title: "Report Development",
    icon: "📈",
    text: "We offer custom report development services to enhance the reporting capabilities of your existing system. Our team collaborates closely with your organisation to design effective reporting solutions."
  }
];

const collaborativeTools = [
  { name: "Git & GitHub", icon: "🐙", text: "We utilise Git and GitHub for version control and collaborative software development, enabling seamless team collaboration." },
  { name: "Jira", icon: "🎯", text: "Powerful project management tool that helps us plan, track, and manage tasks and workflows efficiently." },
  { name: "Confluence", icon: "📖", text: "Serves as a collaborative wiki platform for creating and sharing project documentation and knowledge." },
  { name: "Planning/Review", icon: "🗓️", text: "We utilise various project planning and review tools to ensure effective project organisation and progress tracking." },
  { name: "Slack", icon: "💬", text: "We leverage Slack for real-time collaboration, quick communication, and seamless information sharing." },
  { name: "Scrum and Agile", icon: "⚡", text: "We follow Scrum and Agile methodologies to ensure iterative and flexible project management for high-quality results." }
];

export default function Services() {
  return (
    <div className='bg-light'>
      {/* ── Hero Section ─────────────────────────── */}
      <div
        className="position-relative d-flex align-items-center justify-content-center text-center overflow-hidden"
        style={{
          width: '100%',
          height: '50vh',
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          marginTop: '-1px'
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(180deg, rgba(15,23,42,0.8), rgba(15,23,42,0.5))',
            zIndex: 1
          }}
        />
        <div className="container position-relative px-4" style={{ zIndex: 2 }}>
          <p className="section-label animate-fade-up text-info mb-3">Expert Solutions</p>
          <h1 className="text-white fw-bold animate-fade-up delay-1" style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', lineHeight: 1.1 }}>
            OUR <span className="text-info">SERVICES</span>
          </h1>
          <p className="animate-fade-up delay-2 text-white-50 mt-3 mx-auto" style={{ maxWidth: '600px', fontSize: '1.1rem' }}>
            Transforming challenges into opportunities through innovative IT strategy and robust implementations.
          </p>
        </div>
      </div>

      {/* ── Intro ────────────────────────────────── */}
      <div className="py-5" style={{ backgroundColor: 'var(--ftb-bg-alt)', transition: 'var(--transition)' }}>

        <div className="container text-center">
          <p className="section-subtitle">
            We are a premier provider of IT services dedicated to assisting our international clients in resolving issues,
            implementing solutions, and creating comprehensive documentation to help businesses optimise their operations.
          </p>
        </div>
      </div>

      {/* ── Latest Technology ────────────────────── */}
      <div className='container-fluid py-5 p-4' style={{ background: 'var(--ftb-bg-page)', transition: 'var(--transition)' }}>

        <div className="container">
          <p className="section-label text-center">Innovation</p>
          <h2 className="section-title text-center mb-5">Build Yourself in Latest Technology</h2>
          <div className="row g-4 justify-content-center">
            {coreTechnologies.map((tech, i) => (
              <div className="col-md-4" key={i}>
                <div className="ftb-service-card h-100 text-center p-4">
                  <div className="ftb-card-accent" />
                  <div style={{ fontSize: '3rem', margin: '20px 0' }}>{tech.icon}</div>
                  <h4 className="fw-bold mb-3" style={{ color: 'var(--ftb-text)' }}>{tech.title}</h4>

                  <a href={tech.href} className="btn btn-outline-primary rounded-pill px-4">Learn More</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Comprehensive Range ───────────────────── */}
      <div className='container-fluid py-5' style={{ backgroundColor: 'var(--ftb-bg-alt)', transition: 'var(--transition)' }}>

        <div className="container">
          <p className="section-label text-center">Expertise</p>
          <h2 className="section-title text-center mb-3">Comprehensive Range of Services</h2>
          <p className="section-subtitle text-center mb-5">We offer IT services that leverage our proficiency in cutting-edge technologies to deliver exceptional solutions.</p>

          <div className="row g-4">
            {rangeOfServices.map((service, i) => (
              <div className="col-md-6 col-lg-3" key={i}>
                <div className="ftb-service-card h-100 p-4">
                  <div className="ftb-card-accent" />
                  <div style={{ fontSize: '2.5rem', margin: '15px 0' }}>{service.icon}</div>
                  <h5 className="fw-bold mb-3" style={{ color: 'var(--ftb-text)' }}>{service.title}</h5>
                  <p style={{ color: 'var(--ftb-text-muted)', fontSize: '0.9rem', lineHeight: 1.6 }}>{service.text}</p>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Collaborative Tools ────────────────────── */}
      <div className='container-fluid py-5' style={{ backgroundColor: 'var(--ftb-bg-card)', color: 'var(--ftb-text)', transition: 'var(--transition)' }}>

        <div className="container text-center">
          <p className="section-label mb-2">Workflow</p>
          <h2 className="section-title text-white mb-5">Our Collaborative Tools</h2>
          <div className="row g-5">
            {collaborativeTools.map((tool, i) => (
              <div className="col-md-4" key={i}>
                <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{tool.icon}</div>
                <h5 className="fw-bold mb-3" style={{ color: '#0dcaf0' }}>{tool.name}</h5>
                <p style={{ color: '#94a3b8', fontSize: '0.95rem', lineHeight: 1.7 }}>{tool.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Quote ────────────────────────────────── */}
      <div className='container py-5'>
        <div className="text-center section-title" style={{ color: 'var(--ftb-text)', opacity: 0.9 }}>
          <div style={{ fontSize: '3rem', color: '#0dcaf0', marginBottom: '10px' }}>“</div>
          <div>TALENT WINS GAMES, BUT</div>
          <div>TEAMWORK AND INTELLIGENCE</div>
          <div>WINS CHAMPIONSHIPS.</div>
        </div>
      </div>

    </div>
  );
}
